import template from './detail.html';
import controller from './detail.controller';
import './detail.scss';

let detailComponent = {
  bindings: {
    item: "<",
    modelName: "<"
  },
  template,
  controller,
  controllerAs: "vm"
};

export default detailComponent;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/detail.component.js